var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPersonAttached(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.375 47.531a7.313 7.313 0 00-7.313-7.312H21.938a7.313 7.313 0 00-7.313 7.312v2.438c0 9.608 9.067 19.5 24.375 19.5 15.307 0 24.375-9.892 24.375-19.5V47.53zm-43.875 0a2.437 2.437 0 012.438-2.437h34.124A2.438 2.438 0 0158.5 47.53v2.438c0 7.01-6.981 14.625-19.5 14.625s-19.5-7.615-19.5-14.625V47.53zM52.406 21.938a13.406 13.406 0 00-24.643-7.312H19.5a2.438 2.438 0 00-2.438 2.437v9.75c0 .078 0 .151.01.224h-.01v4.651a7.312 7.312 0 007.313 7.313h1.887a2.989 2.989 0 10-2.292-4.91 2.437 2.437 0 01-2.032-2.403v-2.437h1.218a7.282 7.282 0 003.934-1.15 13.406 13.406 0 0025.316-6.163zm-21.937 0a8.531 8.531 0 1117.062 0 8.531 8.531 0 01-17.062 0zm-4.875 0a2.438 2.438 0 01-2.438 2.438h-1.218V19.5h3.656v2.437z",
    fill: "#2E5ECC"
  })));
}

export default SvgPersonAttached;